import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export function isNotError<T>(value: T | Error): value is T {
	return !(value instanceof Error);
}

export function filterError<T>(source: Observable<T | Error>): Observable<T> {
	return source.pipe(filter(isNotError));
}
